// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","publicationsContainer":"_3Gs5s","title":"LYVhX","cta":"_2s67u"};